import React from 'react';
import { motion } from 'framer-motion';
import { FiCheck, FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  const bullets = [
    'Your team answers first — AI catches what they miss',
    'Answers every call in under 2 seconds, 24/7/365',
    'Auto-forwards to your team when a human is needed — caller stays on the line',
    'Integrates with Salesforce, HubSpot, Zendesk, Freshdesk, and 400+ tools',
    '70–80% cheaper than hiring additional staff',
    '14-day free pilot — see it work before you commit',
  ];

  return (
    <section className="relative pt-24 pb-12 lg:pt-36 lg:pb-20 overflow-hidden bg-white">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10">
        <div className="absolute -top-[20%] -right-[10%] w-[700px] h-[700px] rounded-full bg-green-50/60 blur-3xl pointer-events-none"></div>
        <div className="absolute top-[20%] -left-[10%] w-[500px] h-[500px] rounded-full bg-slate-50/80 blur-3xl pointer-events-none"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-900 text-white text-sm font-semibold mb-6 shadow-lg shadow-slate-900/20">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
            14-Day Free Pilot — No Setup Fee, No Commitment
          </div>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-slate-900 mb-6 tracking-tight leading-tight">
            Stop Losing Customers<br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-slate-700">
              {' '}to Missed Calls
            </span>
          </h1>
          <h2 className="text-lg md:text-2xl text-slate-600 mb-6 font-medium max-w-3xl mx-auto">
            We replace voicemail with AI so every missed call becomes a booked job, a captured lead, or a structured handoff — not a lost customer.
          </h2>
          <p className="text-base md:text-lg text-slate-500 mb-8 max-w-2xl mx-auto leading-relaxed">
            Your staff still answers first. When they're busy, after hours, or unavailable — AI catches the call, captures the details, and connects callers to your team when needed. Think of it as replacing voicemail, not replacing your office.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10">
            <button
              onClick={() => scrollToSection('booking-section')}
              className="w-full sm:w-auto group bg-green-700 text-white px-8 py-4 rounded-xl text-lg font-bold hover:bg-green-800 transition-all shadow-xl shadow-green-700/20 flex items-center justify-center gap-2"
            >
              Start Free Pilot
              <SafeIcon icon={FiArrowRight} className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => scrollToSection('roi-calculator')}
              className="w-full sm:w-auto px-8 py-4 rounded-xl text-lg font-semibold text-slate-700 border border-slate-200 hover:border-slate-300 hover:bg-slate-50 transition-all"
            >
              Calculate Your Savings
            </button>
          </div>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-600">
            {bullets.map((item, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiCheck} className="w-3 h-3 text-green-700" />
                </div>
                {item}
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;